$("#iconos-cercanos-a .iconos").slick({
    arrows: false,
    autoplay: true,
    dots: false,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 3,
});

if (screen.width >= 768) {
    $("#iconos-cercanos-a .iconos").slick("unslick");
}